import type { QueryResultWithRefetch } from '@confluence/legacy-schema-bridge/entry-points/useExperimentalQuery.ts';
import { useExperimentalQuery } from '@confluence/legacy-schema-bridge/entry-points/useExperimentalQuery.ts';
import { MediaType } from '@confluence/graphql/entry-points/MediaType.ts';

import type {
	EditorBreadcrumbsQuery as EditorBreadcrumbsQueryData,
	EditorBreadcrumbsQueryVariables,
} from './__types__/EditorBreadcrumbsQuery.ts';

interface BreadcrumbItem {
	title: string | null;
	url: string | null;
}

interface BreadcrumbApiResponse {
	breadcrumbs?: BreadcrumbItem[];
}

export const useExperimentalEditorBreadcrumbsQuery = ({
	variables,
	skip,
	onError,
}: {
	variables: EditorBreadcrumbsQueryVariables;
	skip?: boolean;
	onError?: (error: Error) => void;
}): QueryResultWithRefetch<EditorBreadcrumbsQueryData, EditorBreadcrumbsQueryVariables> => {
	const { contentId } = variables;

	return useExperimentalQuery<
		EditorBreadcrumbsQueryData,
		EditorBreadcrumbsQueryVariables,
		BreadcrumbApiResponse
	>({
		url: `/wiki/pages/breadcrumb.action?pageId=${contentId}`,
		method: 'GET',
		headers: {
			'Content-Type': MediaType.JSON,
		},
		parseResult: (json, _variables): EditorBreadcrumbsQueryData => {
			if (!contentId) {
				throw new Error('contentId is missing.');
			}

			return {
				experimentalEditorBreadcrumbs: {
					breadcrumbs: json?.breadcrumbs || null,
				},
			};
		},
		skip,
		variables,
		onError,
	});
};
